// extracted by mini-css-extract-plugin
export default {"root":"NavBar_root__vW-or","links":"NavBar_links__tagcI","button":"NavBar_button__xQIwW","setButton":"NavBar_setButton__J6bIX"};